/* Super Socks – Akkordeons statt Reiter auf der Produktseite
 *
 * Die Reiter (Beschreibung, Details, Versand) stehen als HTML in der
 * Produktbeschreibung. Dieses Skript baut daraus beim Laden Akkordeons,
 * ohne die Beschreibung im Admin zu verändern:
 *   - Jeder Inhalt (li#tab1 … li#tab3) bleibt mit seiner Kennung erhalten
 *     und wandert nur in ein Akkordeon-Feld. Texte, Emojis, Links,
 *     Stichpunkte, Waschsymbole und die Versandtabelle bleiben unverändert.
 *   - Beschreibung ist beim Laden offen. Öffnet man ein anderes Feld,
 *     schließt sich das offene.
 *   - Waschsymbole: Antippen zeigt die Erklärung, erneutes Antippen oder
 *     Tippen daneben blendet sie aus.
 * Gilt für alle Produkte. Zum Eingrenzen TEST auf eine Liste von
 * Produkt-IDs setzen, z. B. [7278704853188].
 */
(function () {
  'use strict';
  if (window.SSAkkordeon) return;

  var TEST = null; /* alle Produkte */

  function aktiv(main) {
    var p = main.querySelector('.product-main');
    if (!p) return false;
    if (!TEST) return true;
    for (var i = 0; i < TEST.length; i++) {
      if (p.classList.contains('product-' + TEST[i])) return true;
    }
    return false;
  }

  function oeffnen(liste, item) {
    var items = liste.querySelectorAll('.ss-akk__item');
    for (var i = 0; i < items.length; i++) {
      var auf = items[i] === item && !items[i].classList.contains('is-offen');
      items[i].classList.toggle('is-offen', auf);
      var kopf = items[i].querySelector('.ss-akk__kopf');
      if (kopf) kopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
    }
  }

  function bauen() {
    var main = document.querySelector('.is-product-main');
    if (!main || !aktiv(main)) return;
    var desc = main.querySelector('.product-block--description .description');
    if (!desc || desc.classList.contains('ss-akk')) return;
    var tabs = desc.querySelector('ul.tabs');
    var inhalt = desc.querySelector('ul.tabs-content');
    if (!tabs || !inhalt) return;

    var links = tabs.querySelectorAll('li > a[href^="#"]');
    if (!links.length) return;

    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var id = a.getAttribute('href').slice(1);
      var feld = null;
      for (var j = 0; j < inhalt.children.length; j++) {
        if (inhalt.children[j].id === id) { feld = inhalt.children[j]; break; }
      }
      if (!feld) continue;

      var item = document.createElement('div');
      item.className = 'ss-akk__item ss-akk__item--' + id;
      var kopf = document.createElement('button');
      kopf.type = 'button';
      kopf.className = 'ss-akk__kopf';
      kopf.id = 'ss-akk-kopf-' + id;
      kopf.setAttribute('aria-controls', 'ss-akk-feld-' + id);
      kopf.setAttribute('aria-expanded', 'false');
      kopf.innerHTML = '<span class="ss-akk__titel"></span><span class="ss-akk__zeichen" aria-hidden="true"></span>';
      kopf.querySelector('.ss-akk__titel').textContent = a.textContent.trim();

      var huelle = document.createElement('div');
      huelle.className = 'ss-akk__inhalt';
      huelle.id = 'ss-akk-feld-' + id;
      huelle.setAttribute('role', 'region');
      huelle.setAttribute('aria-labelledby', kopf.id);
      var innen = document.createElement('div');
      innen.className = 'ss-akk__innen';

      inhalt.insertBefore(item, feld);
      innen.appendChild(feld);
      huelle.appendChild(innen);
      item.appendChild(kopf);
      item.appendChild(huelle);
    }

    inhalt.classList.add('ss-akk__liste');
    desc.classList.add('ss-akk');
    var erstes = inhalt.querySelector('.ss-akk__item');
    if (erstes) oeffnen(inhalt, erstes);
  }

  function klick(e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;

    var kopf = ziel.closest('.ss-akk__kopf');
    if (kopf) {
      var liste = kopf.closest('.ss-akk__liste');
      if (liste) oeffnen(liste, kopf.parentNode);
      return;
    }

    /* Waschsymbole: Antippen zeigt die Erklärung */
    var symbol = ziel.closest('.ss-akk__liste .tooltips li');
    var offen = document.querySelectorAll('.ss-akk__liste .tooltips li.is-offen');
    for (var i = 0; i < offen.length; i++) {
      if (offen[i] !== symbol) offen[i].classList.remove('is-offen');
    }
    if (symbol) {
      symbol.classList.toggle('is-offen');
      var leiste = symbol.closest('.tooltips');
      if (leiste) leiste.classList.toggle('hat-offen', symbol.classList.contains('is-offen'));
    } else {
      var leisten = document.querySelectorAll('.ss-akk__liste .tooltips.hat-offen');
      for (var k = 0; k < leisten.length; k++) leisten[k].classList.remove('hat-offen');
    }
  }

  function start() {
    bauen();
    /* InstantClick tauscht beim Seitenwechsel den Body aus */
    if (window.InstantClick && !start.angemeldet) {
      window.InstantClick.on('change', bauen);
      start.angemeldet = true;
    }
  }

  document.addEventListener('click', klick);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.SSAkkordeon = { bauen: bauen };
})();
